import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, usePage, useResource, useStore, useTheme, useToast } from "@/comn/hooks";
import { Link, useNavigate } from "react-router-dom";
import {
    APIS,
    SF_AUTH_MGMT_SRCH,
    SG_AUTH_MGMT_LIST,
    URLS,
} from "@/tz/go/egaz/osci/ptl/ptl/auth/services/OsciAuthService";
import { comnUtils } from "@/comn/utils";
import { useEffect } from "react";

/*
 * Auth Management List
 * !== 권한 관리 목록 ==!
 */
export const OSCI0104010Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate();
    const toast = useToast();
    const { theme } = useTheme();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const form = {
        authMgmtSrch: useForm({ defaultSchema: SF_AUTH_MGMT_SRCH }),
    };

    const grid = {
        authList: useGrid({
            defaultSchema: SG_AUTH_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getAuthList: useFetch({
            api: (page = grid.authList.page, size = grid.authList.size) =>
                APIS.getAuthList(form.authMgmtSrch.getValues(), page, size),
            enabled:
                !comnUtils.isEmpty(form.authMgmtSrch.getValue("bsopClsfCd")) &&
                !comnUtils.isEmpty(form.authMgmtSrch.getValue("ptlTpCd")),
            key: [grid.authList.page, grid.authList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.authMgmtSrch.getValues(),
                    page: grid.authList.page,
                    size: grid.authList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        authList: {
            cell: {
                authId: (props: any) => {
                    const { value } = props;
                    return <Link to={`${URLS.osci0104012s}/${value}`}>{value}</Link>;
                },
            },
        },
    };

    const handler = {
        onGridCellClick: (cell: any) => {
            const { binding, rowValues } = cell;
            if (binding !== "authId") return;

            setStore(pgeUid, {
                ...pgeStore,
                param: {
                    bsopClsfCd: rowValues.bsopClsfCd,
                    ptlTpCd: rowValues.ptlTpCd,
                    authId: rowValues.authId,
                },
            });
        },
        onSrchBtnClick: () => {
            form.authMgmtSrch.handleSubmit(
                () => {
                    grid.authList.setPage(0);
                    fetch.getAuthList.fetch(0);
                },
                () => toast.showToast({ type: "warning", content: "msg.osc.00003" }),
            )();
        },
        onNewBtnClick: () => navigate(`${URLS.osci0104011s}`),
        onClear: () => {
            form.authMgmtSrch.clearValues();
            grid.authList.getData().length > 0 && grid.authList.clearData();
            form.authMgmtSrch.setValue("bsopClsfCd", "OSC");
            form.authMgmtSrch.setValue("ptlTpCd", "O");
        },
    };

    useEffect(() => {
        pgeStore?.form && form.authMgmtSrch.setValues(pgeStore.form);
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.authMgmtSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.authMgmtSrch.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authMgmtSrch.schema.authId} />
                            <Group.Control {...form.authMgmtSrch.schema.authNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Left>
                            <Layout.Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Grid
                        {...grid.authList.grid}
                        data={fetch.getAuthList.data?.authList}
                        render={render.authList}
                        onCellClick={handler.onGridCellClick}
                    />
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Layout.Button role="new" onClick={handler.onNewBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
